module.exports = __webpack_public_path__ + "static/media/23_CORTININHA_SEM_BOJO_ESTAMPADO_01.0c8a2241.jpg";